import { Box, styled } from '@mui/material';

export const Container = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
